var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrow = function SvgArrow(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.749 13.819",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 2683"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.87 13.819a.83.83 0 0 1-.555-.222.787.787 0 0 1 0-1.109l5.575-5.575-5.606-5.575A.787.787 0 0 1 12.397.225l6.129 6.13a.8.8 0 0 1 0 1.109l-6.1 6.129a.88.88 0 0 1-.556.226",
    "data-name": "Pfad 20"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 2684"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.972 7.689H.772a.775.775 0 0 1-.777-.777.794.794 0 0 1 .777-.777h17.2a.777.777 0 1 1 0 1.553Z",
    "data-name": "Pfad 21"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrow);
export default ForwardRef;